

export default function Header() {
  return (
    <>

      <button type="button" className="mobile-nav-toggle d-xl-none">
        <i className="icofont-navigation-menu"></i>
      </button>

      <header id="header">
        <div className="d-flex flex-column">
          <div className="profile">
            <img
              src="i_assets/img/profile-img.webp"
              alt="harsh"
              className="img-fluid rounded-circle"
            />
            <h1 className="text-light">
              <a href="https://www.hptranscoders.com/harsh-nirbhavane">
                Harshal Nirbhavane
              </a>
            </h1>
            <div className="social-links mt-3 text-center">
              <a
                href="tel:+919921839702"
                className="phone"
                target="_blank"
              >
                <i className="icofont-phone"></i>
              </a>

              <a
                href="https://wa.me/919921839702?text=I'm%20interested"
                className="whatsapp"
                target="_blank"
              >
                <i className="bx bxl-whatsapp"></i>
              </a>
              
            </div>
          </div>

          <nav className="nav-menu">
            <ul>
              <li className="active">
                <a href="https://www.hptranscoders.com/harshal-nirbhavane">
                  <i className="bx bx-home"></i> <span>Home</span>
                </a>
              </li>
              <li>
                <a href="#about">
                  <i className="bx bx-user"></i> <span>About</span>
                </a>
              </li>
              <li>
                <a href="#resume">
                  <i className="bx bx-file-blank"></i> <span>Career Profile</span>
                </a>
              </li>
              <li>
                <a href="#portfolio">
                  <i className="bx bx-book-content"></i> Portfolio
                </a>
              </li>

              {/* <li>
                <a href="#contact">
                  <i className="bx bx-envelope"></i> Contact
                </a>
              </li> */}
            </ul>
          </nav>
          <button type="button" className="mobile-nav-toggle d-xl-none">
            <i className="icofont-navigation-menu"></i>
          </button>
        </div>
      </header>

    </>
  );
}
